var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUparrowSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.01172 6.78516L6.1382 4.17286L3.26467 6.78516",
    stroke: "black",
    strokeWidth: 1.04492
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUparrowSvg);
export default __webpack_public_path__ + "static/media/uparrow_svg.50664457a86549b6dfdc3b73d3ec19be.svg";
export { ForwardRef as ReactComponent };